export function createMonitoring({ flowAPI }) {
  return {
    sentry: flowAPI.sentry,
    fedopsLogger: flowAPI.fedops,
  };
}
